'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DirectionalIcon = require('./DirectionalIcon');

var _DirectionalIcon2 = _interopRequireDefault(_DirectionalIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Chevron = function Chevron(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _DirectionalIcon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { fill: fill, points: '14.3,12.6 8,6.3 1.7,12.6 0.3,11.1 8,3.4 15.7,11.1 ' })
      )
    )
  );
};

Chevron.propTypes = _extends({}, _DirectionalIcon2.default.propTypes);

Chevron.defaultProps = _extends({}, _DirectionalIcon2.default.defaultProps);

exports.default = Chevron;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0NoZXZyb24uanMiXSwibmFtZXMiOlsiQ2hldnJvbiIsImZpbGwiLCJwcm9wcyIsImRpc3BsYXkiLCJwcm9wVHlwZXMiLCJkZWZhdWx0UHJvcHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7Ozs7QUFFQSxJQUFNQSxVQUFVLFNBQVZBLE9BQVUsT0FBd0I7QUFBQSxNQUFyQkMsSUFBcUIsUUFBckJBLElBQXFCO0FBQUEsTUFBWkMsS0FBWTs7QUFDdEMsU0FDRTtBQUFBO0FBQXFCQSxTQUFyQjtBQUNFO0FBQUE7QUFBQSxRQUFLLE9BQU8sRUFBRUMsU0FBUyxPQUFYLEVBQVosRUFBa0MsT0FBTSw0QkFBeEMsRUFBcUUsWUFBVyw4QkFBaEYsRUFBK0csR0FBRSxLQUFqSCxFQUF1SCxHQUFFLEtBQXpILEVBQStILE9BQU0sTUFBckksRUFBNEksUUFBTyxNQUFuSixFQUEwSixTQUFRLFdBQWxLO0FBQ0U7QUFBQTtBQUFBO0FBQ0UsbURBQVMsTUFBTUYsSUFBZixFQUFxQixRQUFPLG9EQUE1QjtBQURGO0FBREY7QUFERixHQURGO0FBU0QsQ0FWRDs7QUFZQUQsUUFBUUksU0FBUixnQkFDSywwQkFBZ0JBLFNBRHJCOztBQUlBSixRQUFRSyxZQUFSLGdCQUNLLDBCQUFnQkEsWUFEckI7O2tCQUllTCxPIiwiZmlsZSI6IkNoZXZyb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgRGlyZWN0aW9uYWxJY29uIGZyb20gJy4vRGlyZWN0aW9uYWxJY29uJ1xuXG5jb25zdCBDaGV2cm9uID0gKHsgZmlsbCwgLi4ucHJvcHMgfSkgPT4ge1xuICByZXR1cm4gKFxuICAgIDxEaXJlY3Rpb25hbEljb24gey4uLnByb3BzfT5cbiAgICAgIDxzdmcgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHhtbG5zWGxpbms9J2h0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsnIHg9JzBweCcgeT0nMHB4JyB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJyB2aWV3Qm94PScwIDAgMTYgMTYnPlxuICAgICAgICA8Zz5cbiAgICAgICAgICA8cG9seWdvbiBmaWxsPXtmaWxsfSBwb2ludHM9JzE0LjMsMTIuNiA4LDYuMyAxLjcsMTIuNiAwLjMsMTEuMSA4LDMuNCAxNS43LDExLjEgJyAvPlxuICAgICAgICA8L2c+XG4gICAgICA8L3N2Zz5cbiAgICA8L0RpcmVjdGlvbmFsSWNvbj5cbiAgKVxufVxuXG5DaGV2cm9uLnByb3BUeXBlcyA9IHtcbiAgLi4uRGlyZWN0aW9uYWxJY29uLnByb3BUeXBlc1xufVxuXG5DaGV2cm9uLmRlZmF1bHRQcm9wcyA9IHtcbiAgLi4uRGlyZWN0aW9uYWxJY29uLmRlZmF1bHRQcm9wc1xufVxuXG5leHBvcnQgZGVmYXVsdCBDaGV2cm9uXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Chevron.js
// module id = 1118
// module chunks = 0